import React, { useState, useEffect, useContext } from "react";
import { Content, Container } from "../styles";

import NotFound from "../../../../components/notFound/notFound";

import StatusPayment from "../components/StatusPayment";
import TransactionDetails from "../components/TransactionDetail";
import PayerIdentification from "../components/PayerIdentification";
import PurchaseDetail from "../components/PurchaseDetail";

import reviewImg from "../../../../assets/images/review.svg";

const Revisao = (props) => {
  const transaction_response_message = {
    message: props.location.state?.message,
    response: props.location.state?.response_message
  };
  const payer_data = props.location.state?.payer_data;
  const payment_detail = props.location.state?.payment_detail;
  const transaction_detail = props.location.state?.transaction_detail;
  const style_page = props.location.state?.style_page;

  // const message = "A mensagem virá aqui"

  // const payer_data = {
  //   name: "Thalyson Menezes",
  //   phone: "98981919",
  //   email: "thalyson@menezes.com",
  // };

  // const payment_detail = {
  //   payment_amount: "3000",
  //   authorizer_id: "41",
  //   payment_type: "C",
  //   payment_date: "28/02/2023T16:31",
  //   transaction_code: "2f2f0607fe481ae318e2d06d9d55ed543026afedf0f26b3151ac901473aab8fa",
  // };

  // const transaction_detail = {
  //   order: "100000000001",
  //   product_detail: {
  //     discount: {
  //       type: "amount",
  //       value: 100,
  //     },
  //     items: [
  //       {
  //         product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "PS5",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 400,
  //         quantity: 1,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //       {
  //         // product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "Iphone",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 188155,
  //         quantity: 6,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //     ],
  //   },
  //   shipping_detail: {
  //     type: "correios",
  //     delivery_price: "4200",
  //     delivery_time: 4
  //   }
  // };

  // const style_page = {
  //   background_color: "#000000"
  // }

  const [stage, setStage] = useState(0);

  const statusData = {
    transactionStatus: {
      image: reviewImg,
      title: "Seu pagamento está sendo processado",
      message: "Em breve comunicaremos o resultado final do seu pagamento, através dos canais de contato informados.",
    },
    paymentStatus: {
      status: "review",
      message: "Aguardando processamento",
    },
  };

  useEffect(() => {
    // setStage(1);

    if (props.location.state) {
      setStage(1);
    } else {
      // Página de não encontrado
      setStage(2);
    }
  }, []);

  return (
    <>
      {stage === 1 && (
        <Content bgColor={style_page.background_color || "#E5E5E5"}>
          <Container id="status-payment">
            <StatusPayment
              transactionStatus={statusData.transactionStatus}
              styledPage={style_page}
              responseMessage={transaction_response_message}
            />
          </Container>

          <Container className="other-containers">
            <TransactionDetails
              paymentStatus={statusData.paymentStatus}
              paymentData={payment_detail}
              reiceptButtonColor={style_page.background_color}
            />
          </Container>

          <Container className="other-containers">
            <PurchaseDetail shippingData={transaction_detail} amount={payment_detail.amount} />
          </Container>

          <Container className="other-containers">
            <PayerIdentification identificationData={payer_data} />
          </Container>
        </Content>
      )}
      {stage === 2 && (
        <>
          <NotFound />
        </>
      )}
    </>
  );
};

export default Revisao;
